<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="'/race_type/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <h5>検索</h5>
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">競技種目</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="license_event_list"
                v-model="sprm.license_event_id"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button
              :btnClass="'btn-primary'"
              @to_click_event="search_article"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="w100"
      v-if="
        typeof race_type_list === 'object' &&
        Object.keys(race_type_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 20%">名称</th>
            <th style="width: 10%">格式コード</th>
            <th style="width: 10%">国内/国際</th>
            <th style="width: 10%">種別</th>
            <th style="width: 10%">カテゴリ</th>
            <th style="width: 10%">ソートNo</th>
            <th colspan="2" style="width: 15%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in race_type_list" :key="list.id">
            <td>{{ list.label }}</td>
            <td>{{ list.race_type_cd }}</td>
            <td>{{ list.race_inter_type }}</td>
            <td>{{ list.tournament_type_label }}</td>
            <td>{{ list.race_type_category }}</td>
            <td>{{ list.sort }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-8">
          <bs-page-nav
            :pager_key="'race_type'"
            @to_click_event="pageAction"
          ></bs-page-nav>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'
import BsSelect from '../../atoms/BsSelect.vue'

export default {
  name: 'CategoryListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '格式マスタ一覧',
      fromParentBtn: 'データ登録',
      race_class_obj: [],

      license_event_cd_obj: [],
      race_type_cd_obj: [],
      sprm: {
        license_event_id: ''
      },
      page: 0,
      page_limit: 10
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsSelect,
    BsMsgAlert
  },
  computed: {
    ...mapState({}),
    license_event_list: function () {
      return this.license_event_cd_obj
    },
    race_class_list: function () {
      return this.race_class_obj
    },
    race_type_list: function () {
      const lists = [...this.race_type_cd_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    }
  },

  async created() {
    await this.loadLicenseEventCdList()
    await this.loadRaceClassList()
    await this.loadRaceTypeCdList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = 'クラスマスタです。'
  },

  methods: {
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_event_cd_obj', err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceClassList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_class_data/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceClassList response', response)
          this.race_class_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('race_class_data err', err)
          this.race_class_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.race_type_obj.find(race_type => {
          return race_type.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'race_type' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(async () => {
            await this.loadRaceTypeCdList()
          })
      }
    },
    async loadRaceTypeCdList() {
      const params = {}
      params['stat'] = [1]
      if (this.sprm.license_event_id) {
        params['license_event_id'] = this.sprm.license_event_id
      }
      if (this.sprm.race_type_id) {
        params['race_type_id'] = this.sprm.race_type_id
      }
      params['pagelimit'] = false
      if (this.page >= 0) params['p'] = this.page
      params['pageorder'] = 'mfj_race_type_cd.sort'
      params['pagesort'] = 'ASC'
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'race_type'
      })
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_type_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceTypeCdList response', response)
          this.race_type_cd_obj =
            response.data && response.data.body ? response.data.body : []

          this.$store.dispatch('setSearchParam', {
            data: params,
            target: 'race_type'
          })
          const setPageData = {}
          setPageData.data =
            response.data && response.data.pager ? response.data.pager : {}
          setPageData.target = 'race_type'
          this.$store.dispatch('setPager', setPageData)
        })
        .catch(async err => {
          console.log(err)
          this.race_type_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    handleClick(target) {
      this.$router.push({ path: '/race_type/' + target + '/' })
    }
  }
}
</script>
